export default __webpack_public_path__ + "static/media/besu-bg.69993aad.png";